import useUnarchiveInboundEmail from '@/api/mutations/inbound-emails/useUnarchiveInboundEmail';
import { UnarchiveInboundEmailMutation } from '@/gql/graphql';
import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';
import { createOptimisticMutationOptions } from './createOptimisticMutation';
import {
  applyDetailOptimisticUnarchive,
  applyOptimisticUnarchive,
} from './optimisticUpdates';

const useOptimisticUnarchiveInboundEmail = (
  options?: UseMutationOptions<
    UnarchiveInboundEmailMutation,
    unknown,
    { inboundEmailId: string }
  >
) => {
  const queryClient = useQueryClient();

  const optimistic = createOptimisticMutationOptions(
    queryClient,
    {
      applyToInbox: (data, vars) => applyOptimisticUnarchive(data, vars),
      applyToDetail: (data) => applyDetailOptimisticUnarchive(data),
      tracksUnreadCount: false,
    },
    options
  );

  return useUnarchiveInboundEmail({ ...options, ...optimistic });
};

export default useOptimisticUnarchiveInboundEmail;
